import { render } from "./FinishGiftingNftModal.vue?vue&type=template&id=1d744d62&scoped=true"
import script from "./FinishGiftingNftModal.vue?vue&type=script&lang=js"
export * from "./FinishGiftingNftModal.vue?vue&type=script&lang=js"

import "@/Common/Styles/listNftModal.scss?vue&type=style&index=0&id=1d744d62&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d744d62"]])

export default __exports__